import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

export function* getItemsCategories() {
  try {
    const params = {
      query: {
        limit: 10000,
        page: 1,
      },
    };

    const { data } = yield call(request, API.ITEMS_CATEGORIES, 'GET', params);

    yield put(actions.getItemsCategoriesSuccess(data));
  } catch (e) {
    yield put(actions.getItemsCategoriesError(e));
  }
}

export function* getItemsCategoriesWatcher() {
  yield takeEvery(constants.GET_ITEMS_CATEGORIES, getItemsCategories);
}
